import React from "react";
import { GroupOfOrdersIcon, OrderIcon, AvailableDriverIconModified, BusyDriverIconModified, InfoIcon, OfflineDriverIconModified, StackedShipmentsIcon, StackedDriversIcon, DropOffIcon } from "../../svg";

export default function FloatingInfoMenu() {
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev)
    }
    return (
        <div
            className={`rounded-xl py-2  z-[1100] items-start space-y-4 flex flex-col-reverse cursor-pointer`}>
            <div
                className="shadow rounded-full mr-2 cursor-pointer p-[1px] bg-[#f5f3e6]"
                onClick={handleClick}
                open={open}
                direction="up">
                <InfoIcon />
            </div>
            {open &&
                <div className="absolute bg-white rounded-md flex flex-col p-3 space-y-3 items-start shadow-md"
                    style={{ top: 45, right: 7 }}>
                    <span className="text-[16px] text-gray-500">Map Legends</span>
                    <div className="flex items-center justify-center space-x-2">
                        <span><StackedShipmentsIcon /></span><span className="uppercase font-[500] text-[15px]">Stacked orders</span>
                    </div>
                    <div className="flex items-center justify-center space-x-2">
                        <span><StackedDriversIcon /></span><span className="uppercase font-[500] text-[15px]">Stacked Drivers</span>
                    </div>
                    <div className="h-[1px] w-full bg-gray-300"></div>

                    <div className="flex items-center justify-center space-x-2">
                        <span><GroupOfOrdersIcon /></span><span className="uppercase font-[500] text-[15px]">group of orders</span>
                    </div>
                    <div className="flex items-center justify-center space-x-2">
                        <span><OrderIcon /></span><span className="uppercase font-[500] text-[15px]">single order</span>
                    </div>
                    <div className="h-[1px] w-full bg-gray-300"></div>

                    <div className="flex items-center justify-center space-x-2">
                        <span><AvailableDriverIconModified /></span><span className="uppercase font-[500] text-[15px]">available driver</span>
                    </div>
                    <div className="flex items-center justify-center space-x-2">
                        <span><BusyDriverIconModified /></span><span className="uppercase font-[500] text-[15px]">busy driver</span>
                    </div>
                    <div className="flex items-center justify-start space-x-2">
                        <span ><OfflineDriverIconModified /></span><span className="uppercase font-[500] text-[15px]">offline driver</span>
                    </div>
                    <div className="h-[1px] w-full bg-gray-300"></div>
                    <div className="flex items-center justify-center space-x-2">
                        <span><DropOffIcon /></span><span className="uppercase font-[500] text-[15px]">dropoff</span>
                    </div>
                </div>
            }
        </div>
    );
}
